<template>
<div>


<!-- Vertically centered scrollable modal -->
<div class="modal" id="productImg" style="display: block">

<div  class="modal-dialog modal-dialog-centered " role="document">
   <div class="modal-content ">
  <div class="modal-header ">
      <i style="color:brown" class="fas fa-globe  float-left mr-2" data-toggle="tooltip" :title="img" aria-hidden="true">
        
      </i>
     
      <button @click="$emit('close')"  type="button" class="btn btn-primary btn-rounded ">CHIUDI</button>
      </div>


<span class="border border-warning shadow-lg">
<div class="modal-body  mb-0 p-0">
  <img v-bind:src="img" alt="" style="width:100%" class="rounded">
  
<!--
<div class="modal-footer">
        
   
      </div>


-->
</div>
</span>


</div>  
</div>
</div>


</div>
</template>
<script>


export default {
  props  : ['img'],
  
  data () 
  {
    return {
              
        spinner     : false,
             
    }
    
  },
    
  
}
</script>

<style scoped>



.modal-header {
  *background-color: darkseagreen;
  color           : black;
}

 .modal { 
  text-align: center; 
        } 
i
{
  cursor: pointer;
}
 .border {
    border-width:3px !important;
}       
</style>
